'use client'

import { cx } from 'classix'
import type React from 'react'
import { type ReactNode, useRef } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import styles from './CustomCursor.module.css'
import { useCustomCursor } from './hooks/useCustomCursor'

interface CustomCursorProps {
	readonly children: ReactNode
	readonly cursorContent: ReactNode
	readonly className?: string
	readonly zIndex?: number
}

export const CustomCursor: React.FC<CustomCursorProps> = ({
	children,
	cursorContent,
	className,
	zIndex = 1,
}) => {
	const containerRef = useRef<HTMLDivElement>(null)
	const { position, isVisible } = useCustomCursor(containerRef)
	const { isTouchable } = useResponsive()

	if (isTouchable) {
		return <>{children}</>
	}

	return (
		<div className={cx(className, styles.container)} ref={containerRef}>
			{isVisible && (
				<div
					className={styles.cursor}
					style={{ left: `${position.x}px`, top: `${position.y}px`, zIndex }}
				>
					{cursorContent}
				</div>
			)}
			{children}
		</div>
	)
}
